export default "__VITE_ASSET__qyPjrudx__"